import React from 'react';
import { IDeveloperImage } from 'utils/entities';
import { SectionWrapper } from 'screens/DeveloperPage/styled';
import Gallery from './Gallery';


interface DeveloperGalleryProps {
  images: IDeveloperImage[];
  developerName: string;
}

const Overview: React.FC<DeveloperGalleryProps> = ({ images, developerName }) => {
  return (
    <SectionWrapper noTopMargin>
      <Gallery images={images} developerName={developerName} />
    </SectionWrapper>
  );
};

export default React.memo(Overview);
